const targetDefinitions = {
  details: {
    selector: '.text-block--text_YL9nqF',
    labels: ['Shipping & Delivery'],
  },
  reviews: {
    selector: '#shopify-section-175837120230fc62b2, .jdgm-review-widget',
    labels: ['Customer Reviews', 'Reviews'],
    useSection: true,
  },
  faqs: {
    selector: '#shopify-section-section_yV46mC',
    labels: ['Frequently asked questions'],
    useSection: true,
  },
};

class ProductAnchorNav extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (event) => {
    const link = event.target.closest('[data-anchor-target]');
    if (!(link instanceof HTMLAnchorElement) || !this.contains(link)) return;

    const targetName = link.dataset.anchorTarget;
    const target = this.#findTarget(targetName);
    if (!(target instanceof HTMLElement)) return;

    event.preventDefault();
    const markerId = `product-anchor-${targetName}`;
    let marker = document.getElementById(markerId);

    if (!marker) {
      marker = document.createElement('span');
      marker.id = markerId;
      marker.className = 'product-anchor-target';
      marker.setAttribute('aria-hidden', 'true');
      target.before(marker);
    }

    marker.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start',
    });
    history.replaceState(null, '', `#${markerId}`);
  };

  #findTarget(targetName) {
    const definition = targetDefinitions[targetName];
    if (!definition) return null;

    const selectedTarget = document.querySelector(definition.selector);
    if (selectedTarget) {
      return definition.useSection ? selectedTarget.closest('.shopify-section') || selectedTarget : selectedTarget;
    }

    const candidates = document.querySelectorAll('main h1, main h2, main h3, main h4, main p, main .text-block');
    return Array.from(candidates).find((candidate) => {
      const text = candidate.textContent?.replace(/\s+/g, ' ').trim();
      return definition.labels.includes(text);
    });
  }
}

if (!customElements.get('product-anchor-nav')) {
  customElements.define('product-anchor-nav', ProductAnchorNav);
}
